import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// 根组件下两个大的子组件
import login from '../components/login/login.vue'


import {orgRoute} from './orgRoute';
import {branchRoute} from './branchRoute';
let router = {
  // mode: "history",
  routes: [
    {
      path: "/",
      redirect: "login"
    },
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path:"/login/changePwd",
      name:"changePwd",
      component: ()=> import("@/components/login/changePwd.vue")
    },
    {
      path:"/login/changePhone",
      name:"changePhone",
      component: ()=> import("@/components/login/changePhone.vue")
    },
    {
      path:"/login/forgetPassword",
      name:"forgetPassword",
      component: ()=> import("@/components/login/forgetPassword.vue")
    },
    {
      path:"/sweepCodeEntry/customer",
      name:"sweepCodeEntryForCustomer",
      component: ()=> import("@/pages/common/sweepCodeEntry/customer")

    },
    {
      path:"/sweepCodeEntry/customer/success",
      name:"sweepCodeEntryForCustomerSuccess",
      component: ()=> import("@/pages/common/sweepCodeEntry/customer/success")

    },
    {
      path: "/test/map",
      name: "test/map",
      component: ()=> import("@/components/map/test.vue")
    }, 
    {
      path: "/abc",
      name: "abc",
      component: ()=> import("@/pages/branch/handle/enroll")
    }, 
    {
      path: "/ab",
      name: "ab",
      component: ()=> import("@/pages/organization/insurance")
    }, 
    {
      path: "/test/ueditor",
      name: "test/ueditor",
      component: ()=> import("@/components/Ueditor/APP.vue")
    },
    orgRoute,
    branchRoute
  ]
}
export default new Router(router);



// WEBPACK FOOTER //
// ./src/router/index.js